module.exports = __webpack_public_path__ + "img/event-square-3.0909dc58.jpg";